<template>
  <div class="settings--content">
    <loading-state v-if="uiFlags.isFetching" />
    <form v-else-if="!error_not_implemented" @submit.prevent="saveCallSettings" style="width: 100%;">
      <!-- General Calling Settings -->
      <settings-section
        :title="$t('CALL_PAGE.CALL_SETTING.ALLOW_CALL.TITLE')"
        :sub-title="$t('CALL_PAGE.CALL_SETTING.ALLOW_CALL.DESC')"
      >
        <div class="medium-2 columns settings-item">
            <label>
                <select v-model="callSettings.status">
                    <option value="ENABLED">{{ $t('CALL_PAGE.CALL_SETTING.ALLOW_CALL.ENABLE') }}</option>
                    <option value="DISABLED">{{ $t('CALL_PAGE.CALL_SETTING.ALLOW_CALL.DISABLE') }}</option>
                </select>
            </label>
            <woot-submit-button
              :button-text="$t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON')"
              :loading="uiFlags.isUpdating"
            />
        </div>
      </settings-section>

      <settings-section
        :title="$t('CALL_PAGE.CALL_SETTING.ALLOW_CALLBACK.TITLE')"
        :sub-title="$t('CALL_PAGE.CALL_SETTING.ALLOW_CALLBACK.DESC')"
      >
        <div class="medium-2 columns settings-item">
            <label>
                <select v-model="callSettings.callback_permission_status">
                    <option value="ENABLED">{{ $t('CALL_PAGE.CALL_SETTING.ALLOW_CALLBACK.ENABLE') }}</option>
                    <option value="DISABLED">{{ $t('CALL_PAGE.CALL_SETTING.ALLOW_CALLBACK.DISABLE') }}</option>
                </select>
            </label>
            <woot-submit-button
              :button-text="$t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON')"
              :loading="uiFlags.isUpdating"
            />
        </div>
      </settings-section>
      
      <!-- <settings-section
        :title="$t('CALL_PAGE.CALL_SETTING.SHOW_ICON_BTN_CALL.TITLE')"
        :sub-title="$t('CALL_PAGE.CALL_SETTING.SHOW_ICON_BTN_CALL.DESC')"
      >
        <div class="medium-2 columns settings-item">
            <label>
                <select v-model="callSettings.call_icon_visibility">
                    <option value="DEFAULT">{{ $t('CALL_PAGE.CALL_SETTING.SHOW_ICON_BTN_CALL.ENABLE') }}</option>
                    <option value="DISABLE_ALL">{{ $t('CALL_PAGE.CALL_SETTING.SHOW_ICON_BTN_CALL.DISABLE') }}</option>
                </select>
            </label>
            <woot-submit-button
              :button-text="$t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON')"
              :loading="uiFlags.isUpdating"
            />
        </div>
      </settings-section> -->

      <!-- Call Hours Settings -->
      <settings-section
        :title="$t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.TITLE')"
        :sub-title="$t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.DESC')"
      >
        <div class="medium-9 columns settings-item">
            <div class="form-group">
                <label>               
                {{ $t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.ENABLE') }}
                </label>
            </div>

            <div v-if="callHoursEnabled">
                <div class="form-group">
                  <label>{{ $t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.TIMEZONE_LABEL') }}</label>
                  <multiselect
                    v-model="timezone"
                    :options="timeZones"
                    deselect-label=""
                    select-label=""
                    selected-label=""
                    track-by="value"
                    label="label"
                    :close-on-select="true"                    
                    :allow-empty="false"
                    :placeholder="$t('CALL_PAGE.CALL_SETTING.PLACEHOLDER_SELECT')"
                  />
                </div>

                <div class="weekly-hours">
                <h4>{{ $t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.WEEKLY_HOURS') }}</h4>
                <div 
                    v-for="day in weekDays" 
                    :key="day.value"
                    class="day-schedule"
                >
                    <div class="day-row">
                    <div class="day-name">
                        <label>
                        <input 
                            type="checkbox" 
                            :checked="isDayActive(day.value)"
                            @change="toggleDay(day.value, $event)"
                        >
                        {{ day.label }}
                        </label>
                    </div>
                    
                    <div v-if="isDayActive(day.value)" class="time-inputs">
                        <div class="time-group">
                        <label>{{ $t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.FROM_LABEL') }}</label>
                        <input 
                            type="time" 
                            :value="getDayOpenTime(day.value)"
                            @input="updateDayTime(day.value, 'open_time', $event.target.value)"
                        >
                        </div>
                        <div class="time-group">
                        <label>{{ $t('CALL_PAGE.CALL_SETTING.HOUR_CALL_AVAILABILITY.TO_LABEL') }}</label>
                        <input 
                            type="time" 
                            :value="getDayCloseTime(day.value)"
                            @input="updateDayTime(day.value, 'close_time', $event.target.value)"
                        >
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <woot-submit-button
              :button-text="$t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON')"
              :loading="uiFlags.isUpdating"
            />
        </div>
      </settings-section>

      <!-- Holiday Schedule -->
      <settings-section
        v-if="callHoursEnabled"
        :title="$t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.TITLE')"
        :sub-title="$t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.DESC')"
      >
        <div class="medium-9 columns settings-item">
          <div class="holiday-schedule">
            <div class="add-holiday">
              <h4>{{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.ADD_HOLIDAY_BTN') }}</h4>
              <div class="holiday-form">
                <div class="form-group">
                  <label>{{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.HOLIDAY_DATE_LABEL') }}</label>
                  <input 
                    type="date" 
                    v-model="newHoliday.date"
                    min="2024-01-01"
                  >
                </div>
                <div class="form-group">
                  <label>{{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.HOLIDAY_START_TIME_LABEL') }}</label>
                  <input 
                    type="time" 
                    v-model="newHoliday.start_time"
                  >
                </div>
                <div class="form-group">
                  <label>{{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.HOLIDAY_END_TIME_LABEL') }}</label>
                  <input 
                    type="time" 
                    v-model="newHoliday.end_time"
                  >
                </div>
                <button 
                  type="button" 
                  class="button small"
                  @click="addHoliday"
                  :disabled="!isHolidayValid"
                >
                    {{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.ADD_BTN') }}
                </button>
              </div>
            </div>

            <div v-if="showHolidaySchedule" class="holidays-list">
              <h4>{{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.HOLIDAYS_LIST') }}</h4>
              <div 
                v-for="(holiday, index) in callSettings.call_hours.holiday_schedule"
                :key="index"
                class="holiday-item"
              >
                <div class="holiday-info">
                  <span>{{ formatDate(holiday.date) }}</span>
                  <span>{{ formatTime(holiday.start_time) }} - {{ formatTime(holiday.end_time) }}</span>
                </div>
                <button 
                  type="button" 
                  class="button small alert"
                  @click="removeHoliday(index)"
                >
                    {{ $t('CALL_PAGE.CALL_SETTING.HOLIDAY_SCHEDULE.REMOVE_BTN') }}
                </button>
              </div>
            </div>
          </div>
          <woot-submit-button
              :button-text="$t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON')"
              :loading="uiFlags.isUpdating"
            />
        </div>
      </settings-section>

      <!-- Submit Button -->
      <settings-section
        :title="$t('CALL_PAGE.CALL_SETTING.TEMPLATES.TITLE')"
        sub-title=""
      >
        <template #subTitle>
         <div v-dompurify-html="formatMessage($t('CALL_PAGE.CALL_SETTING.TEMPLATES.DESC'))"></div>
        </template>
        <div class="medium-9 columns settings-item">
          <h4>{{ $t('CALL_PAGE.CALL_SETTING.TEMPLATES.CONFIGURE') }}</h4>
          <div>
            <label>{{ $t('CALL_PAGE.CALL_SETTING.TEMPLATES.REQUEST_CALL_COMPANY') }}</label>            
            <multiselect
              v-model="templateCallVoice"
              :options="templateOptions"
              deselect-label=""
              select-label=""
              selected-label=""
              track-by="value"
              label="label"
              :close-on-select="true"                    
              :allow-empty="false"
              :placeholder="$t('CALL_PAGE.CALL_SETTING.PLACEHOLDER_SELECT')"
            />
          </div>
          <div>
            <label>{{ $t('CALL_PAGE.CALL_SETTING.TEMPLATES.REQUEST_PERMISSION_PHONE_CONTACT') }}</label>            
            <multiselect
              v-model="templateCallPermissionRequest"
              :options="templateOptions"
              deselect-label=""
              select-label=""
              selected-label=""
              track-by="value"
              label="label"
              :close-on-select="true"                    
              :allow-empty="false"
              :placeholder="$t('CALL_PAGE.CALL_SETTING.PLACEHOLDER_SELECT')"
            />
          </div>
          <woot-button
            type="button"
             :loading="uiFlags.isUpdating"
            @click="updateInbox"
          >{{ $t('CALL_PAGE.CALL_SETTING.SUBMIT_BUTTON') }}</woot-button>
        </div>
      </settings-section>
    </form>
    <div v-else class="alert alert-warning">{{ $t('CALL_PAGE.ERROR_NOT_IMPLEMENTED') }}</div>
  </div>
</template>

<script>

import alertMixin from 'shared/mixins/alertMixin';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';

import { mapGetters } from 'vuex';
import SettingsSection from 'dashboard/components/SettingsSection';
import LoadingState from 'dashboard/components/widgets/LoadingState';

import {  
  timeZoneOptions,
} from '../helpers/businessHour';

const DEFAULT_TIMEZONE = {
  label: 'America/Sao_Paulo',
  value: 'America/Sao_Paulo',
};

export default {
  components: {
    SettingsSection,
    LoadingState,
  },
  mixins: [alertMixin, messageFormatterMixin],
  props: {
    inbox: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      callSettings: {
        status: "ENABLED",
        call_icon_visibility: "DEFAULT",
        call_hours: {
          status: "DISABLED",
          timezone_id: DEFAULT_TIMEZONE.value,
          weekly_operating_hours: [],
          holiday_schedule: []
        },
        callback_permission_status: "ENABLED"
      },
      newHoliday: {
        date: '',
        start_time: '00:00',
        end_time: '23:59'
      },
      weekDays: [
        { value: 'MONDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.MONDAY') },
        { value: 'TUESDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.TUESDAY') },
        { value: 'WEDNESDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.WEDNESDAY') },
        { value: 'THURSDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.THURSDAY') },
        { value: 'FRIDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.FRIDAY') },
        { value: 'SATURDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.SATURDAY') },
        { value: 'SUNDAY', label: this.$t('CALL_PAGE.CALL_SETTING.WEEK_DAYS.SUNDAY') }
      ],
      showHolidaySchedule: false,
      templateCallVoice: null,
      templateCallPermissionRequest: null,
      error_not_implemented: false,
      timezone: DEFAULT_TIMEZONE,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'call/getUIFlags',
      settings: 'call/getSettings',
    }),
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    callHoursEnabled() {
      return this.callSettings.call_hours.status == "ENABLED";
    },
    isHolidayValid() {
      return this.newHoliday.date && 
             this.newHoliday.start_time && 
             this.newHoliday.end_time;
    },
    timeZones() {
      return [...timeZoneOptions()];
    },
    templateOptions(){
      if(this.inbox.message_templates){
        return this.inbox.message_templates.sort((a, b) => a.name.localeCompare(b.name)).map(template => ({
          label: template.name,
          value: template.name
        }));
      }
      return []      
    }
  },
  watch: {
    'callSettings.status'(newStatus) {
      if (this.callSettings?.call_hours) {
        this.callSettings.call_hours.status = newStatus;
      }
    },
  },
  mounted() {
    this.loadCallSettings();
    if (this.inbox.call_settings) {
      if(this.inbox.call_settings.template_call_voice){
        this.templateCallVoice = this.templateOptions.find(template => template.value == this.inbox.call_settings.template_call_voice) || null;      
      }
      if(this.inbox.call_settings.template_call_permission_request){
        this.templateCallPermissionRequest = this.templateOptions.find(template => template.value == this.inbox.call_settings.template_call_permission_request) || null;
      }
    }
  },
  methods: {
    async loadCallSettings() {
      try{
        await this.$store.dispatch('call/getSettings', { inboxId: this.inbox.id });
      }catch(error){        
        this.error_not_implemented = error.response && error.response.status === 501;
        if(this.error_not_implemented){
          return;
        }
      }
      if(Object.keys(this.settings).length === 0){
        this.showAlert(this.$t('CALL_PAGE.CALL_SETTING.ERROR_FETCH'));
        return;
      }
      const settings = JSON.parse(JSON.stringify(this.settings));
      let timezone = null;
      if(settings && settings.call_hours && settings.call_hours.timezone_id){
        timezone = this.timeZones.find(tz => tz.value === settings.call_hours.timezone_id);
      }
      // Força atualizar config da ligação
      this.callSettings = {
        ...this.callSettings,
        ...settings,
        call_hours: {
          ...this.callSettings.call_hours,
          ...(settings.call_hours ?? {}),
        },
      };
      if(timezone){
        this.timezone = timezone
        
      }
      this.checkHolidaySchedule();
    },

    checkHolidaySchedule() {
      this.showHolidaySchedule = !!(this.callSettings.call_hours?.holiday_schedule?.length > 0);
    },

    toggleCallHours() {
      if (!this.callHoursEnabled) {
        this.callSettings.call_hours.weekly_operating_hours = [];
        this.callSettings.call_hours.holiday_schedule = [];
      }
    },

    isDayActive(dayOfWeek) {
      return this.callSettings.call_hours.weekly_operating_hours
        .some(day => day.day_of_week === dayOfWeek);
    },

    toggleDay(dayOfWeek, event) {
      const isEnabled = event.target.checked;
      const existingDayIndex = this.callSettings.call_hours.weekly_operating_hours
        .findIndex(day => day.day_of_week === dayOfWeek);

      if (isEnabled && existingDayIndex === -1) {
        this.callSettings.call_hours.weekly_operating_hours.push({
          day_of_week: dayOfWeek,
          open_time: "0800",
          close_time: "1800"
        });
      } else if (!isEnabled && existingDayIndex !== -1) {
        this.callSettings.call_hours.weekly_operating_hours.splice(existingDayIndex, 1);
      }
    },

    getDayOpenTime(dayOfWeek) {
      const day = this.callSettings.call_hours.weekly_operating_hours
        .find(d => d.day_of_week === dayOfWeek);
      return day ? this.timeToHHMM(day.open_time) : "08:00";
    },

    getDayCloseTime(dayOfWeek) {
      const day = this.callSettings.call_hours.weekly_operating_hours
        .find(d => d.day_of_week === dayOfWeek);
      return day ? this.timeToHHMM(day.close_time) : "18:00";
    },

    updateDayTime(dayOfWeek, field, value) {
      const day = this.callSettings.call_hours.weekly_operating_hours
        .find(d => d.day_of_week === dayOfWeek);
      if (day) {
        day[field] = this.timeToHHMM24(value);
      }
    },

    timeToHHMM(time24) {
      // Convert "0800" to "08:00"
      if (time24 && time24.length === 4) {
        return time24.substring(0, 2) + ':' + time24.substring(2);
      }
      return time24;
    },

    timeToHHMM24(timeHHMM) {
      // Convert "08:00" to "0800"
      return timeHHMM.replace(':', '');
    },

    addHoliday() {
      if (this.isHolidayValid) {
        if (!this.callSettings.call_hours?.holiday_schedule) {
          this.callSettings.call_hours.holiday_schedule = [];
        }
        this.callSettings.call_hours.holiday_schedule.push({
          date: this.newHoliday.date,
          start_time: this.timeToHHMM24(this.newHoliday.start_time),
          end_time: this.timeToHHMM24(this.newHoliday.end_time)
        });
        
        // Reset form
        this.newHoliday = {
          date: '',
          start_time: '00:00',
          end_time: '23:59'
        };

        this.checkHolidaySchedule();
      }
    },

    removeHoliday(index) {
      this.callSettings.call_hours.holiday_schedule.splice(index, 1);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('pt-BR');
    },

    formatTime(time24) {
      return this.timeToHHMM(time24);
    },

    async saveCallSettings() {
      try {
        if(this.callSettings.call_hours.status == "ENABLED"){
          const weekly_operating_hours_valid = this.callSettings.call_hours.weekly_operating_hours.filter((item) => {
            if(item.open_time != "" && item.close_time != ""){
               var startTime = new Date();
              startTime.setHours(item.open_time.substring(0,2));
              startTime.setMinutes(item.open_time.substring(3,5));
              startTime.setSeconds(0);

              var endTime = new Date();
              endTime.setHours(item.close_time.substring(0,2));
              endTime.setMinutes(item.close_time.substring(3,5));
              endTime.setSeconds(0);
              
              return (startTime.getTime() <= endTime.getTime());              
            }
            return false;
          });
          if(weekly_operating_hours_valid.length == 0 || weekly_operating_hours_valid.length != this.callSettings.call_hours.weekly_operating_hours.length){
            this.showAlert(this.$t('CALL_PAGE.CALL_SETTING.ERROR_TIME_VALIDATION'));
            return;
          }
        }

        let payload = this.callSettings;
        payload.call_hours.timezone_id = this.timezone.value;        

        await this.$store.dispatch('call/updateSettings', { inboxId: this.inbox.id, payload });
        this.showAlert(this.$t('CALL_PAGE.CALL_SETTING.SUCCESS_UPDATE'));
      } catch (error) {
        console.log(error)
        this.showAlert(this.$t('CALL_PAGE.CALL_SETTING.ERROR_UPDATE'));
      }
    },

    async updateInbox($event) {
      try {        
        const payload = {
          id: this.currentInboxId,
          formData: false,
          call_settings: {
            template_call_voice: this.templateCallVoice ? this.templateCallVoice.value : null,
            template_call_permission_request: this.templateCallPermissionRequest ? this.templateCallPermissionRequest.value : null,
          },
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },
  }
}
</script>

<style scoped lang="scss">
.settings--content {
  .form-group {
    margin-bottom: var(--space-normal);
    
    label {
      display: block;
      margin-bottom: var(--space-smaller);
      font-weight: var(--font-weight-medium);
      color: var(--s-700);
    }

    select, input {
      width: 100%;
      padding: var(--space-smaller);
      border: 1px solid var(--color-border);
      border-radius: var(--border-radius-small);
      font-size: var(--font-size-small);

      &:focus {
        border-color: var(--color-woot);
        outline: none;
        box-shadow: 0 0 0 1px var(--color-woot);
      }
    }

    input[type="checkbox"] {
      width: auto;
      margin-right: var(--space-smaller);
    }

    input[type="time"], input[type="date"] {
      width: auto;
    }
  }

  .weekly-hours {
    margin-top: var(--space-normal);
    
    h4 {
      margin-bottom: var(--space-normal);
      color: var(--s-800);
      font-weight: var(--font-weight-medium);
    }

    .day-schedule {
      margin-bottom: var(--space-small);
      
      .day-row {
        display: flex;
        align-items: center;
        padding: var(--space-small);
        background-color: var(--color-background);
        border: 1px solid var(--color-border-light);
        border-radius: var(--border-radius-small);
        
        .day-name {
          width: 160px;
          
          label {
            display: flex;
            align-items: baseline;
            margin-bottom: 0;
            font-weight: var(--font-weight-normal);
            cursor: pointer;
          }
        }
        
        .time-inputs {
          display: flex;
          gap: var(--space-normal);
          flex: 1;
          
          .time-group {
            display: flex;
            flex-direction: column;
            
            label {
              font-size: var(--font-size-mini);
              margin-bottom: var(--space-micro);
              color: var(--s-600);
            }
          }
        }
      }
    }
  }

  .holiday-schedule {
    .add-holiday {
      margin-bottom: var(--space-large);
      
      h4 {
        margin-bottom: var(--space-normal);
        color: var(--s-800);
        font-weight: var(--font-weight-medium);
      }
      
      .holiday-form {
        display: flex;
        gap: var(--space-normal);
        align-items: end;
        flex-wrap: wrap;
        
        .form-group {
          margin-bottom: 0;
          min-width: 120px;
        }
        
        button {
          margin-bottom: 0;
        }
      }
    }
    
    .holidays-list {
      h4 {
        margin-bottom: var(--space-normal);
        color: var(--s-800);
        font-weight: var(--font-weight-medium);
      }
      
      .holiday-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--space-small);
        background-color: var(--color-background);
        border: 1px solid var(--color-border-light);
        border-radius: var(--border-radius-small);
        margin-bottom: var(--space-small);
        
        .holiday-info {
          display: flex;
          gap: var(--space-normal);
          
          span {
            font-size: var(--font-size-small);
            color: var(--s-700);
            
            &:first-child {
              font-weight: var(--font-weight-medium);
            }
          }
        }
      }
    }
  }

  .settings-submit {
    margin-top: var(--space-large);
    padding-top: var(--space-normal);
    border-top: 1px solid var(--color-border-light);
  }
  .alert {
    color: #030303;
    padding: 1rem 1.8rem;
    font-size: 1.5rem;
    border-radius: 5px;
    margin-bottom: 1.8rem;
    &.alert-warning {
        background: #FFF3D5;    
    }
}
}

.button {
  &.small {
    padding: var(--space-smaller) var(--space-small);
    font-size: var(--font-size-mini);
  }
  
  &.alert {
    background-color: var(--r-400);
    color: white;
    border: 1px solid var(--r-400);
    
    &:hover {
      background-color: var(--r-500);
      border-color: var(--r-500);
    }
  }
}
</style>